// ===== Mueblika · Formulario de lead (compartido) =====
// Se usa en Home, Contacto y Ficha de producto. Valida SIEMPRE en el
// navegador antes de enviar: teléfono (9 dígitos, empieza por 6 o 7),
// casilla de privacidad marcada, y que Cloudflare Turnstile haya
// soltado su token (verificación real de que no es un bot).
//
// El envío al Apps Script va como JSON "en crudo" (sin FormData) y
// SIN fijar el header Content-Type a mano — así el navegador lo
// manda como texto plano, evitando el "preflight" de CORS que
// Apps Script no sabe responder bien. Es el formato que Apps
// Script interpreta de forma fiable con JSON.parse(e.postData.contents).

(function () {

  // Teléfono: deja solo los 9 dígitos. Si lo pegan o el móvil lo
  // autocompleta con prefijo (+34, 0034 o 34 delante), espacios,
  // puntos, guiones o paréntesis, se limpia solo.
  function mbkLimpiarTelefono(v) {
    v = v.replace(/[\s.\-()]/g, '').replace(/^(\+34|0034)/, '').replace(/\D/g, '');
    if (/^34[67][0-9]{8}$/.test(v)) v = v.slice(2);
    return v.slice(0, 9);
  }
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('.mbk-lead-form');

    forms.forEach(function (form) {
      var isCrmMode = form.hasAttribute('data-mbk-crm-form');
      var endpoint = form.dataset.endpoint;

      // Los mensajes de éxito/error están fuera del <form>, dentro
      // del mismo contenedor .mbk-lead
      var wrap = form.closest('.mbk-lead');
      var successMsg = wrap ? wrap.querySelector('[data-mbk-lead-success]') : null;
      var errorMsg = wrap ? wrap.querySelector('[data-mbk-lead-error]') : null;
      var submitBtn = form.querySelector('.mbk-lead-form__submit');

      var phoneInput = form.querySelector('input[type="tel"]');
      var privacidadInput = form.querySelector('input[name="acepta_privacidad"], input[name="contact[acepta_privacidad]"]');
      var turnstileInput = form.querySelector('[data-mbk-turnstile-input]');

      // ---------- Teléfono: se limpia solo mientras se escribe o se pega ----------
      if (phoneInput) {
        phoneInput.removeAttribute('maxlength');
        ['input', 'change'].forEach(function (ev) {
          phoneInput.addEventListener(ev, function () {
            var limpio = mbkLimpiarTelefono(phoneInput.value);
            if (limpio !== phoneInput.value) phoneInput.value = limpio;
          });
        });
      }

      var phonePattern = /^[67][0-9]{8}$/;

      function showError(text) {
        if (errorMsg) {
          errorMsg.textContent = text;
          errorMsg.hidden = false;
        }
      }

      function validate() {
        if (successMsg) successMsg.hidden = true;
        if (errorMsg) errorMsg.hidden = true;

        if (phoneInput && !phonePattern.test(phoneInput.value)) {
          showError('El teléfono debe tener 9 dígitos y empezar por 6 o 7.');
          phoneInput.focus();
          return false;
        }

        if (privacidadInput && !privacidadInput.checked) {
          showError('Tienes que aceptar la Política de Privacidad para poder enviar el formulario.');
          return false;
        }

        if (isCrmMode && turnstileInput && !turnstileInput.value) {
          showError('Espera un momento a que se complete la verificación de seguridad, y vuelve a intentarlo.');
          return false;
        }

        return true;
      }

      form.addEventListener('submit', function (e) {
        if (!validate()) {
          e.preventDefault();
          return;
        }

        // Formulario nativo de Shopify: si la validación pasó, se deja
        // continuar el envío normal
        if (!isCrmMode) return;

        // Modo CRM: se intercepta y se envía como JSON
        e.preventDefault();

        if (errorMsg) errorMsg.hidden = true;
        if (successMsg) successMsg.hidden = true;
        if (submitBtn) submitBtn.disabled = true;

        var nameInput = form.querySelector('input[name="name"]');
        var categoriaInput = form.querySelector('input[name="categoria"]');
        var comercialInput = form.querySelector('input[name="acepta_comercial"]');

        var payload = {
          name: nameInput ? nameInput.value : '',
          phone: phoneInput ? phoneInput.value : '',
          categoria: categoriaInput ? categoriaInput.value : 'General',
          acepta_privacidad: privacidadInput && privacidadInput.checked ? 'Sí' : 'No',
          acepta_comercial: comercialInput && comercialInput.checked ? 'Sí' : 'No',
          turnstileToken: turnstileInput ? turnstileInput.value : ''
        };

        // Sin headers: el navegador manda esto como texto plano,
        // evitando el preflight de CORS que rompe con Apps Script
        fetch(endpoint, {
          method: 'POST',
          body: JSON.stringify(payload),
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data && data.result === 'error') {
              throw new Error(data.message || 'No se pudo verificar el formulario');
            }
            if (successMsg) successMsg.hidden = false;
            form.reset();
            if (window.turnstile) window.turnstile.reset();
          })
          .catch(function (err) {
            showError(err.message || 'Ha ocurrido un error al enviar el formulario. Inténtalo de nuevo.');
            if (window.turnstile) window.turnstile.reset();
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    });
  });
})();